import React from 'react';
import { observer } from 'mobx-react';
import { samplingDistributions } from 'mobx-store';

import CategoricalComponent from './Component';

const CategoricalContainer = observer(
  class CategoricalContainer extends React.Component {
    render () {
      return (
        <CategoricalComponent
          {...samplingDistributions.samplesSpecifications}
          parameterLevel={samplingDistributions.parameterLevel}
          parameterName={samplingDistributions.parameter.name}
        />
      );
    }
  }
);

export default CategoricalContainer;
